/*
 * @Descripttion:
 * @Author: olei<wangzheng_jzb@100tal.com>
 * @Date: 2020-09-08 17:15:05
 * @LastEditors: olei<wangzheng_jzb@100tal.com>
 * @LastEditTime: 2020-09-16 18:25:35
 */
import initAPI from '../../initAPI';
var apiName = 'biz.util.openMediaFileDialog';
function openMediaFileDialog(params) {
  initAPI(apiName, {
    params: params
  });
}
export { openMediaFileDialog };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/api/biz/util/openMediaFileDialog.js
// module id = null
// module chunks = 